import { render, staticRenderFns } from "./FormOrder.vue?vue&type=template&id=2141f136&"
import script from "./FormOrder.vue?vue&type=script&lang=js&"
export * from "./FormOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports